<template>
    <div>
        <div ref="tagRef" class="tags" v-if="pageshow" @click="toggle">订单 <br> 信息</div>
        <div v-show="visible" ref="popoverRef" class="custom-popover" :style="popoverStyle">
            <div class="popover-arrow"></div>
            <div class="popover-body">
                <div class="h-36px flex justify-between items-center">
                    <span class="header-title">订单信息 </span>
                </div>
                <ul>
                    <div style="margin-top: 10px;">
                        <strong> 做图状态：</strong>
                        <span :style="{ color: route.query.now_state !== '待做图' ? 'green' : '' }">
                            {{ route.query.now_state }}
                        </span>
                    </div>
                    <div style="margin-top: 10px;"> <strong> 订单编号：</strong>{{ orderinfo.order_no }}</div>
                    <div style="margin-top: 10px;"> <strong> 定制信息：</strong>{{ orderinfo.staff_node }}</div>
                    <div style="margin-top: 10px;"> <strong> 买家留言：</strong>{{ orderinfo.buyer_msg }}</div>
                    <div style="margin-top: 10px;"> <strong> 打印备注：</strong>{{ orderinfo.print_remark }}</div>
                    <div style="margin-top: 10px;"> <strong> 后台备注：</strong>{{ orderinfo.notes }}</div>
                </ul>
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue'
import { getOrderInfo } from '@/api/affairs'
import { useRouter, useRoute } from "vue-router";
const route = useRoute()
const visible = ref(false)
const tagRef = ref<HTMLElement | null>(null)
const popoverStyle = ref<Record<string, string>>({})
const popoverRef = ref<HTMLElement | null>(null)


const pageshow = computed(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const order_no = urlParams.get('order_no')
    return order_no
})



let orderinfo = ref<any>({})
const computePosition = () => {
    const el = tagRef.value
    if (!el) return
    const rect = el.getBoundingClientRect()
    const left = rect.right + 12
    const popH = popoverRef.value ? popoverRef.value.offsetHeight : 0
    const top = rect.top + (rect.height - popH) / 2
    popoverStyle.value = {
        position: 'fixed',
        left: `${left}px`,
        top: `${top}px`,
        width: '220px',
        zIndex: '1000'
    }
}

const toggle = async () => {
    visible.value = !visible.value
    if (visible.value) {
        await nextTick()
        computePosition()
    }
}

onMounted(async () => {
    await nextTick()
    computePosition()
    window.addEventListener('resize', computePosition)
    const urlParams = new URLSearchParams(window.location.search)
    const order_no = urlParams.get('order_no')
    if (order_no) {
        visible.value = true
        await nextTick()
        computePosition()
        getOrderInfo({ order_no }).then(async res => {
            if (res.data.code == 200) {
                orderinfo.value = res.data.data
                orderinfo.value.order_no = order_no
                await nextTick()
                computePosition()
            }
        })
    }
})

onUnmounted(() => {
    window.removeEventListener('resize', computePosition)
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tags {
    position: fixed;
    left: 16px;
    bottom: 200px;
    z-index: 999;
    background-color: #2a66ff;
    color: #fff;
    padding: 8px 14px;
    border-radius: 10px;
    box-shadow: 0 6px 16px rgba(42, 102, 255, 0.35);
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.5px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid rgba(255, 255, 255, 0.35);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    cursor: pointer;
}

.tags:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(42, 102, 255, 0.4);
}

.custom-popover {
    position: fixed;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
    padding: 12px;
}

.popover-arrow {
    position: absolute;
    left: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #fff;
    filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.08));
}

.popover-body {
    min-height: 60px;
}
</style>
